import MenuIcon from '@components/atoms/icons/MenuIcon';
import type { FC } from 'react';

type Props = {
  subtitle: string;
  onMenuClick?: () => void;
  className?: string;
};

export const MobileStepHeader: FC<Props> = ({
  subtitle,
  onMenuClick,
  className,
}) => {
  return (
    <div className={`lg:hidden bg-white w-full ${className ?? ''}`}>
      <div className="bg-gradient-to-r from-[#DC0C23] to-[#B4272D] rounded-b-3xl p-4 pr-5 h-24 flex items-center">
        <button
          type="button"
          aria-label="Abrir menú"
          onClick={onMenuClick}
          className="inline-flex items-center justify-center h-10 w-10 rounded-xl bg-white/20 backdrop-blur-sm"
        >
          <MenuIcon className="h-4 w-4 fill-white" />
        </button>

        <div className="ml-auto text-right">
          <div className="text-white font-bold leading-5">Pacific Bank</div>
          <div className="text-white/90 text-xs sm:text-sm">{subtitle}</div>
        </div>
      </div>
    </div>
  );
};

export default MobileStepHeader;
